module.exports = "/_next/static/resources/photo-1-4b46631da4e7a5ea67c5783bbebd92c2.jpg";